import { useMemo } from 'react';
import { roundTo } from '../utils/geometry/epsilon';
import createSafeEvaluator from '../utils/eval/createSafeEvaluator';

export const useTransitionCalculations = form => {
  // const [costGroundTripNational, setCostGroundTripNational] = useState(0);
  // const [saleGroundTripNational, setSaleGroundTripNational] = useState(0);
  // const [costTotalNational, setCostTotalNational] = useState(0);
  // const [saleTotalNational, setSaleTotalNational] = useState(0);

  // const [gst, setGST] = useState(0);
  // const [saleAfterGST, setSaleAfterGST] = useState(0);
  // const [profit, setProfit] = useState(0);
  // const [percentProfit, setPercentProfit] = useState(0);

  const getFormValue = (key, defaultValue = 0) => {
    const value = form.getFieldValue?.(key);
    return value !== undefined && value !== null ? value : defaultValue;
  };

  const getFormValues = () => ({
    exchangeRate: getFormValue('exchangeRate', 1),
    shippingFeeForeign: getFormValue('shippingFeeForeign', 0),
    shippingFeeForeignProfit: getFormValue('shippingFeeForeignProfit', 0),
    GST: getFormValue('GST', 0),
    CIT: getFormValue('CIT', 0),
    grand: getFormValue('grand', 0),
    grandCost: getFormValue('grandCost', 0),
    grandSpecialTexture: getFormValue('grandSpecialTexture', 0),
    importDuty: getFormValue('importDuty', 0),
    groundTripProfit: getFormValue('groundTripProfit', 0),
    groundTripForeign: getFormValue('groundTripForeign', 0),
  });

  const calculateCostNational = useMemo(() => {
    return arr => {
      const result = arr?.reduce((total, item) => {
        try {
          const cost = roundTo(item.cost, 0);
          return total + cost;
        } catch (error) {
          console.log(error);
          return total;
        }
      }, 0);

      return result;
    };
  }, []);

  const calculateSaleNational = useMemo(() => {
    return arr => {
      const result = arr?.reduce((total, item) => {
        try {
          const profit = getFormValue(item.name);
          const sale = (() => {
            if (item.baseFormulaWithProfit) {
              return createSafeEvaluator(item.baseFormulaWithProfit, {
                cost: item.cost,
                profit,
              });
            } else {
              return roundTo(item.sale, 0);
            }
          })();
          return total + sale;
        } catch (error) {
          console.log(error);
          return total;
        }
      }, 0);

      return result;
    };
  }, [getFormValue]);

  // const calculateSaleImportDutyNational = useMemo(() => {
  //   return () => {
  //     const importDutyValue = getFormValue('importDuty', 0);
  //     const grandValue = getFormValue('grand', 0);
  //     return roundTo(importDutyValue * grandValue, 0);
  //   };
  // }, []);

  // const calculateCostShippingFeeNational = useMemo(() => {
  //   return () => {
  //     const exchangeRate = getFormValue('exchangeRate', 1);
  //     const shippingFeeForeign = getFormValue('shippingFeeForeign', 0);
  //     return roundTo(shippingFeeForeign * exchangeRate, 0);
  //   };
  // }, []);

  // const calculateSaleShippingFeeNational = useMemo(() => {
  //   return () => {
  //     const costShippingFeeNational = calculateCostShippingFeeNational();
  //     const profit = getFormValue('shippingFeeForeignProfit', 0);
  //     return roundTo(costShippingFeeNational / (1 - profit), 0);
  //   };
  // }, [calculateCostShippingFeeNational]);

  // const calculateCostGroundTripNational = useMemo(() => {
  //   return () => {
  //     const groundTripForeign = getFormValue('groundTripForeign', 0);
  //     const exchangeRate = getFormValue('exchangeRate', 1);
  //     return roundTo(groundTripForeign * exchangeRate, 0);
  //   };
  // }, []);

  // const calculateSaleGroundTripNational = useMemo(() => {
  //   return () => {
  //     const costGroundTripNational = calculateCostGroundTripNational();
  //     const profit = getFormValue('groundTripProfit', 0);
  //     return roundTo(costGroundTripNational / (1 - profit), 0);
  //   };
  // }, [calculateCostGroundTripNational]);

  // const calculateCostTotalNational = useMemo(() => {
  //   return () => {
  //     const costNational = calculateCostNational();
  //     const costShippingFeeNational = calculateCostShippingFeeNational();
  //     const costGroundTripNational = calculateCostGroundTripNational();
  //     return roundTo(
  //       costNational + costShippingFeeNational + costGroundTripNational,
  //       0
  //     );
  //   };
  // }, [
  //   calculateCostNational,
  //   calculateCostShippingFeeNational,
  //   calculateCostGroundTripNational,
  // ]);

  // const calculateSaleTotalNational = useMemo(() => {
  //   return () => {
  //     const saleNational = calculateSaleNational();
  //     const saleImportDutyNational = calculateSaleImportDutyNational();
  //     const saleShippingFeeNational = calculateSaleShippingFeeNational();
  //     const saleGroundTripNational = calculateSaleGroundTripNational();
  //     return roundTo(
  //       saleNational +
  //         saleShippingFeeNational +
  //         saleGroundTripNational +
  //         saleImportDutyNational,
  //       0
  //     );
  //   };
  // }, [
  //   calculateSaleNational,
  //   calculateSaleShippingFeeNational,
  //   calculateSaleImportDutyNational,
  //   calculateSaleGroundTripNational,
  // ]);

  const calculateGST = useMemo(() => {
    return saleTotalNational => {
      const gstRate = getFormValue('GST', 0) / 100;
      return roundTo(saleTotalNational * gstRate, 0);
    };
  }, [getFormValue]);

  const calculateSaleTotalAfterGST = useMemo(() => {
    return saleTotalNational => {
      const gst = calculateGST(saleTotalNational);
      return roundTo(saleTotalNational + gst, 0);
    };
  }, [calculateGST]);

  const calculateProfit = useMemo(() => {
    return ({ costTotalNational, saleTotalAfterGST }) => {
      return roundTo(Number(saleTotalAfterGST) - Number(costTotalNational), 0);
    };
  }, []);

  const calculatePercentProfit = useMemo(() => {
    return data => {
      const totalAfterGST = calculateSaleTotalAfterGST(
        calculateSaleNational(data)
      );
      const profit = calculateProfit({
        costTotalNational: calculateCostNational(data),
        saleTotalAfterGST: totalAfterGST,
      });
      if (totalAfterGST === 0) return 0;
      return roundTo((profit / totalAfterGST) * 100, 2);
    };
  }, [
    calculateProfit,
    calculateSaleTotalAfterGST,
    calculateSaleNational,
    calculateCostNational,
  ]);

  const calculateSale = useMemo(() => {
    return ({ name, cost, baseFormulaWithProfit }) => {
      const profit = getFormValue(name);
      const result = (() => {
        if (baseFormulaWithProfit) {
          return createSafeEvaluator(baseFormulaWithProfit, { cost, profit });
        } else {
          return 0;
        }
      })();

      return result;
    };
  }, [getFormValue]);

  return {
    getFormValue,
    getFormValues,
    calculateSale,
    calculateCostNational,
    calculateSaleNational,
    // calculateSaleImportDutyNational,
    // calculateCostShippingFeeNational,
    // calculateSaleShippingFeeNational,
    // calculateCostGroundTripNational,
    // calculateSaleGroundTripNational,
    // calculateCostTotalNational,
    // calculateSaleTotalNational,
    calculateGST,
    calculateSaleTotalAfterGST,
    calculateProfit,
    calculatePercentProfit,
  };
};
